import { createClient } from '@supabase/supabase-js';

// Get Supabase credentials from environment variables
let supabaseUrl = (process.env.REACT_APP_SUPABASE_URL || '').trim();
const supabaseAnonKey = (process.env.REACT_APP_SUPABASE_ANON_KEY || '').trim();

// Remove any trailing spaces, invalid characters, and normalize the URL
// This fixes issues where URLs might have spaces that get encoded as %20
supabaseUrl = supabaseUrl
  .replace(/\s+/g, '') // Remove all whitespace (spaces, tabs, newlines)
  .replace(/\/$/, '') // Remove trailing slashes
  .replace(/%20/g, ''); // Remove any already-encoded spaces

// URL validation is done silently without logging for security

// Validate URL before creating client
if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('⚠️ Supabase credentials are missing. Realtime features will not work.');
  console.warn('Please check your REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY environment variables.');
} else {
  // Validate URL format
  try {
    const url = new URL(supabaseUrl);
    if (!url.hostname.includes('supabase.co')) {
      console.warn('⚠️ Supabase URL format may be incorrect. Expected format: https://[project-ref].supabase.co');
    }
  } catch (e) {
    console.error('❌ Invalid Supabase URL format:', supabaseUrl);
  }
  
  // Validate API key format (should be a JWT)
  if (supabaseAnonKey && !supabaseAnonKey.includes('.')) {
    console.warn('⚠️ Supabase API key format may be incorrect. Expected a JWT token.');
  }
}

// Create Supabase client
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: false, // We're using backend cookies for auth
    autoRefreshToken: false,
  },
  realtime: {
    params: {
      eventsPerSecond: 10 // Limit events for performance
    }
  }
});

export default supabase;
